import { CustomFormSubscription } from 'ev-api/core/custom-forms';

import { Id } from './common';
import { DynamicFormFieldAttributes } from './dynamic-form-field';
import { ProviderAssignmentStrategy } from './provider-assignment';

export enum VisitTypeJoinVisitAssignment {
  AssignToJoiningProvider = 'assign_to_joining_provider',
  KeepExistingProviderAssignment = 'keep_existing_provider_assignment',
}

export type VisitType = {
  id: Id;
  attributes: VisitTypeAttributes;
  intakeForm: DynamicFormFieldAttributes[];
  customForms: CustomFormSubscription[];
};

export type VisitTypeData = {
  id: Id;
  type: 'visit_type';
  attributes: VisitTypeAttributes;
  relationships: {
    active_intake_form?: {
      data: {
        id: string;
        type: string;
      };
    };
    custom_form_subscriptions: Array<{
      id: Id;
      type: 'custom_form_subscription';
    }>;
  };
};

export type VisitTypeVerbiage = {
  id: Id;
  attributes: VisitTypeVerbiageAttributes;
};

type VisitTypeVerbiageAttributes = {
  content: string;
  locale: string;
  name: string;
};

type VisitTypeAttributes = {
  allow_visit_patient_location_override: boolean;
  accept_first_available: boolean;
  auto_scheduling_enabled: boolean;
  billing_default_price_cents: number | null;
  billing_default_price_range: Array<string | null>;
  billing_reasons_for_no_charge: string[];
  billing_require_credit_card: string;
  chat_enabled: boolean;
  can_modify_cosign_request: boolean;
  default_video_mode: string;
  description: string;
  eprescribe_enabled: boolean;
  eprescribe_mailorder_pharmacies: boolean;
  // first_available_main_provider: null
  first_available_provider: Id | null;
  forbid_patient_cancelations: boolean;
  force_first_available: boolean;
  has_available_main_providers: boolean;
  has_available_providers: boolean;
  hide_copay_amount: boolean;
  hide_scheduled_date_time: boolean;
  hide_provider: boolean;
  hide_estimated_duration: boolean | null;
  id: Id;
  insurance_manual_price_cents: number;
  insurance_manual_price_range: Array<string | null>;
  insurance_medical_service_types: string[];
  // insurance_supported_price_cents: null
  insurance_price: string | null;
  insurance_supported_price_range: Array<string | null>;
  join_visit_assignment: VisitTypeJoinVisitAssignment;
  // kind: null
  main_provider: boolean;
  name: string;
  view_only_attachments: boolean;
  phi_require_chart_confirmation: boolean;
  // phi_require_health_record: []
  position: number;
  post_visit_messaging_enabled: boolean;
  post_visit_messaging_lock_hours: number;
  post_visit_messaging_patient_lock_hours: number;
  practice_id: Id;
  provider_assignment: {
    individual_provider_id: Id | null;
    provider_group_id: Id | null;
    strategy: ProviderAssignmentStrategy;
  };
  provider_groups: Array<{
    id: Id;
    available: boolean;
  }>;
  reassign_provider_enabled: boolean;
  require_verification_for_insurance_price: boolean;
  sip_enabled: boolean;
  status: string;
  suitable_for_escalating_policy: string;
  show_recent_patients: boolean;
  hides_patient_selection: boolean;
  select_from_patient_census?: boolean;
  timing_estimated_duration_minutes: number;
  timing_estimated_wait_time_minutes: number;
  timing_impending_buffer_minutes: number;
  timing_max_duration_minutes: number;
  timing_max_respond_time: number;
  timing_max_respond_time_enabled: boolean;
  timing_min_wait_time: number;
  // timing_reschedule_prompt_interval_seconds: null
  timing_scheduled_visit_buffer_for_patients: number;
  timing_scheduled_visit_expiration_minutes: number;
  timing_submitted_visit_expiration_minutes: number;
  trigger_all_providers_observers_on_first_available: boolean;
  // verbiages: [,…]
  //waiting_room_max_capacity: null
  disable_unavailable_providers: boolean;
  permission_required_to_join: boolean;
  allow_patient_completion: boolean;
};

type CondensedVisitTypeAttributes = {
  id: Id;
  name: string;
  chat_enabled: boolean;
  eprescribe_enabled: boolean;
  hide_provider: boolean;
  hide_scheduled_date_time: boolean;
};

export type CondensedVisitType = {
  id: Id;
  attributes: CondensedVisitTypeAttributes;
};
